import PropTypes from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogEventRowAction = ({
  content,
  title
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "heading-50",
    paddingBlockEnd: content ? '200' : undefined,
    children: title
  }), content]
});
LogEventRowAction.propTypes = {
  content: PropTypes.node,
  title: PropTypes.node
};
export default LogEventRowAction;